import { Container, Typography, Grid, Button, makeStyles } from '@material-ui/core';
import { useAppStateContext } from '../../../AppStateProvider/AppStateProvider';
import { QualityScore } from '../Quality';
import Excellent from './img-speed-score.svg';
import { ViewIcon } from '../../../../icons/ViewIcon';
import { PrimaryButton } from '../../../common/PrimaryButton';
import React from 'react';

const useStyles = makeStyles({
  modal: {
    width: '6000px',
  },
  illustrationContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    '@media screen and (max-width: 950px)': {
      justifyContent: 'center',
    },
  },
  viewButton: {
    marginTop: '0px',
    marginRight: '40px',
    '& svg': {
      position: 'relative',
      left: '-5px',
    },
    '@media screen and (max-width: 351px)': {
      marginTop: '10px',
    },
  },
  image: {
    width: '245px',
    height: '320px',
    '@media screen and (max-width: 761px)': {
      marginTop: '12px',
      width: '30vh',
      height: 'auto',
      maxWidth: '100%',
    },
  },
  gridContainer: {
    justifyContent: 'space-between',
    alignItems: 'center',
    '@media screen and (max-width: 950px) and (min-width: 761px)': {
      display: 'flex',
      flexWrap: 'nowrap',
    },
    '@media screen and (max-width: 760px)': {
      justifyContent: 'center',
    },
  },
  buttonGrid: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    '@media screen and (max-width: 950px)': {
      justifyContent: 'flex-start',
    },
    '@media screen and (max-width: 351px)': {
      flexDirection: 'column',
      alignItems: 'flex-start',
    },
  },
});

interface ExcellentQualityProps {
  quality: QualityScore;
  openModal: () => void;
}

export function ExcellentQuality({ quality, openModal }: ExcellentQualityProps) {
  const { nextPane, state, dispatch } = useAppStateContext();
  const classes = useStyles();

  const qualityScore = quality === QualityScore.Excellent ? 'excellent' : 'good';
  const finishedDeviceCheck = !state.deviceTestIsNotFinished;
  function setDeviceTestIsNotFinished() {
    dispatch({ type: 'set-device-test-not-finished', state: true });
    return undefined;
  }

  function setDeviceTestIsFinished() {
    dispatch({ type: 'set-device-test-not-finished', state: false });
    nextPane();
  }

  return (
    <Container>
      <Grid container className={classes.gridContainer}>
        <Grid item md={5}>
          <Typography variant="h1" gutterBottom>
            Expected quality is {qualityScore}
          </Typography>

          <Typography variant="body1" gutterBottom>
            This is the last step! Your expected audio and video quality is <strong>{qualityScore}</strong> and overall
            performance looks {qualityScore === 'excellent' ? 'good' : 'ok'}.
          </Typography>

          <Grid item className={classes.buttonGrid} direction="row">
            <PrimaryButton onClick={finishedDeviceCheck ? setDeviceTestIsFinished : setDeviceTestIsNotFinished}>
              Finish Up!
            </PrimaryButton>
            <Button color="primary" variant="outlined" disableRipple onClick={openModal} className={classes.viewButton}>
              <ViewIcon />
              View detailed information
            </Button>
          </Grid>
        </Grid>

        <Grid item md={5} className={classes.illustrationContainer}>
          <img src={Excellent} alt="Success" className={classes.image} />
        </Grid>
      </Grid>
    </Container>
  );
}
